import styled from "styled-components";
import { JackpotThemeType } from "../../../../../../services/jackpots/jackpot.constants";
import {JackpotWidgetClockLabelDefaultBox} from "./jackpot-widget-clock-label.default.box";
import {isHotRecurringJackpotState} from "../../../../../../services/jackpots/models/jackpot.view-model.interface";

export const JackpotWidgetClockLabelCasino777Box = styled(JackpotWidgetClockLabelDefaultBox)`
    color: ${({state, theme, themeType}) => themeType === JackpotThemeType.Light ? (isHotRecurringJackpotState(state)  ? theme.colors.danger : theme.colors.textContrast) : theme.colors.brandSecondary};
`;
